<template>
  <v-dialog
    :content-class="`${dialog_class}`"
    v-model="viewedEntityDialogLocalState"
    transition="scale-transition"
    @update:returnValue="onPopupClose"
    scrollable
    @keydown.esc="setViewedEntityDialog(false);" >
    <v-card xs12 v-if="isEntityLoaded">
      <v-card-title class="documentDialog_title primary" dark>
        <v-layout row wrap >
          <v-flex xs11>
            <name-section></name-section>
            <!-- <p v-text="getWikiEntity.entity_name" /> -->
          </v-flex>
          <v-flex xs1 style="text-align: right;">
            <v-btn dark icon
            @click.native="setViewedEntityDialog(false)" >
                <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text >
        <v-layout row wrap >
          <v-flex xs12 lg10>
            <entity-type-relation-section></entity-type-relation-section>
          </v-flex>
          <v-flex xs12 lg2 v-bind="bin_button_visible_md">
            <change-request-section :entityName="getWikiEntity.entity_name"></change-request-section>
          </v-flex>

          <v-flex xs12>
            <attributes-section></attributes-section>
            <br/>
            <links-section></links-section>
            <rich-text-section></rich-text-section>
            <p v-bind="bin_button_visible_xs">
              <change-request-section :entityName="getWikiEntity.entity_name"></change-request-section>
            </p>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions class="bottom_panel">
        <v-btn color="primary" flat
        @click.native="setViewedEntityDialog(false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import NameSection from './NameSection.vue'
import EntityTypeRelationSection from './EntityTypeRelationSection.vue'
import AttributesSection from './AttributesSection.vue'
import RichTextSection from './RichTextSection.vue'
import LinksSection from './LinksSection.vue'
import ChangeRequestSection from './ChangeRequestSection.vue'
import GET_WIKI_ENTITY from '@/graphql/Wiki/GetWikiEntity.gql'

export default {
  name: 'WikiPage',
  data () {
    return {
      getWikiEntity: false
    }
  },
  components: {
    NameSection,
    EntityTypeRelationSection,
    AttributesSection,
    RichTextSection,
    LinksSection,
    ChangeRequestSection
  },
  computed: {
    ...mapState('wiki', ['entityId', 'viewedEntityDialog']),
    isEntityLoaded () {
      if (this.getWikiEntity && this.getWikiEntity.entity_id === parseInt(this.entityId)) {
        return true
      }
      return false
    },
    bin_button_visible_xs () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.style = 'visibility: hidden; height: 0px;'
      return binding
    },
    bin_button_visible_md () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndDown) binding.style = 'visibility: hidden; height: 0px;'
      return binding
    },
    dialog_class () {
      return this.$vuetify.breakpoint.mdAndDown ? 'documentDialog wiki-entity-lower-md' : 'documentDialog wiki-entity'
    },
    viewedEntityDialogLocalState: {
      get () {
        return this.viewedEntityDialog
      },
      set (value) {
        this.setViewedEntityDialog(value)
      }
    }
  },
  methods: {
    ...mapMutations(['addError']),
    ...mapMutations('wiki', ['setViewedEntityDialog', 'setViewedEditEntityDialog']),
    onPopupClose (event) {
      if (event === undefined) {
        this.setViewedEntityDialog(false)
      }
    },
    editEntity () {
      this.setViewedEntityDialog(false)
      this.setViewedEditEntityDialog(true)
    }
  },
  apollo: {
    getWikiEntity: {
      query: GET_WIKI_ENTITY,
      variables () {
        return {
          entity_id: parseInt(this.entityId)
        }
      },
      skip () {
        return this.$route.name !== 'wiki' || !this.entityId
      }
    }
  }
}
</script>
<style>
.wiki-entity {
  margin:0px;
  width:80%;
}
.wiki-entity-lower-md {
  margin:0px;
  width:100%!important;
}
</style>
